import { useRef, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePrevious = (value: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref: React.RefObject<null> = useRef(null);

  useEffect(() => {
    if (ref) {
      ref.current = value;
    }
  }, [value]);

  return ref.current;
};
